export type ResizerEnv = "dev" | "test" | "production";
export const urlRegexes: { [key in ResizerEnv]: RegExp[] } = {
  dev: [
    /^https?:\/\/img\.ifit-dev\.com\/(static\/)?/,
    /^https?:\/\/s3\.amazonaws\.com\/img\.ifit\.com\/dev\//,
    /^https?:\/\/s3\.amazonaws\.com\/image-auto-resizer-dev\/(static\/)?/
  ],
  test: [
    /^https?:\/\/img\.ifit-test\.com\/(static\/)?/,
    /^https?:\/\/s3\.amazonaws\.com\/img\.ifit\.com\/test\//,
    /^https?:\/\/s3\.amazonaws\.com\/image-auto-resizer-test\/(static\/)?/
  ],
  // tslint:disable-next-line: object-literal-sort-keys
  production: [
    /^https?:\/\/img\.ifit\.com\/(static\/)?/,
    /^https?:\/\/s3\.amazonaws\.com\/img\.ifit\.com\//,
    /^https?:\/\/s3\.amazonaws\.com\/image-auto-resizer-production\/(static\/)?/
  ]
};

const domains: { [key in ResizerEnv]: string } = {
  dev: "img.ifit-dev.com",
  test: "img.ifit-test.com",
  // tslint:disable-next-line: object-literal-sort-keys
  production: "img.ifit.com"
};

const getResizerDomain = (env?: ResizerEnv | string) => {
  return domains[env || "dev"] || domains.dev;
};

export default getResizerDomain;
